import SkeletonCard from 'react-loading-skeleton'
import { FC } from 'react'
import { Content, DefaultPage } from '@shared/layout/DefaultPage'
import { BackArrowHeader } from '@widgets/BackArrowHeader'
import { Inline } from '@shared/layout/Inline'
import { Heading } from '@ui/Heading'

interface ExerciseInfoPageSkeletonProps {
	goBackFunction: () => void
}

export const ExerciseInfoPageSkeleton: FC<ExerciseInfoPageSkeletonProps> = ({ goBackFunction }) => {
	return (
		<DefaultPage>
			<Content>
				<BackArrowHeader goBackFunction={goBackFunction}>
					<SkeletonCard
						className={'ml-7 rounded-none'}
						width={162}
						height={22}></SkeletonCard>
				</BackArrowHeader>
				<SkeletonCard height={179} className={'mt-4 rounded-[35px]'}></SkeletonCard>
				<div className={'mt-6'}>
					<Heading>Как выполнять</Heading>
					<SkeletonCard className={'mt-2'} height={84} />
				</div>
				<div className={'mt-6'}>
					<Heading>Области внимания</Heading>
					<Inline className={'mt-2 gap-x-2'}>
						<SkeletonCard
							width={86}
							height={30}
							className={'rounded-[20px]'}></SkeletonCard>
						<SkeletonCard
							width={86}
							height={30}
							className={'rounded-[20px]'}></SkeletonCard>
					</Inline>
				</div>
				<SkeletonCard height={179} className={'mt-3 rounded-[35px]'}></SkeletonCard>
			</Content>
		</DefaultPage>
	)
}
